import { useState } from 'react';

type PublicAvatarProps = {
  src?: string | null;
  name: string;
  initials: string;
  size?: number;
};

// Feed and notification APIs return URLs only after public-photo opt-in.
export default function PublicAvatar({ src, name, initials, size = 36 }: PublicAvatarProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const imageUrl = typeof src === 'string' && /^https:\/\//i.test(src) ? src : null;
  const showImage = Boolean(imageUrl && failedSrc !== imageUrl);
  return (
    <span role="img" aria-label={`${name} avatar`}
      style={{ display: 'inline-flex', width: size, height: size, minWidth: size,
        flexShrink: 0, borderRadius: '50%', background: '#e9eee9',
        color: '#41634c', overflow: 'hidden', alignItems: 'center',
        justifyContent: 'center', fontWeight: 700, fontSize: Math.max(11, Math.floor(size / 3)) }}>
      {showImage ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={imageUrl!} alt="" loading="lazy" referrerPolicy="no-referrer"
          onError={() => setFailedSrc(imageUrl)} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      ) : <span aria-hidden="true">{(initials || 'CM').slice(0, 2).toUpperCase()}</span>}
    </span>
  );
}
